<template>
  <div id="app">
    <navbar></navbar>
    <router-view/>
  </div>
</template>

<script>
// import { mapGetters } from "vuex";

import navbar from "./components/Navbar";
export default {
  name: 'app',
  components: {
    navbar
  }
}
</script>

<style>
#app {
  font-family:ToyotaType-Regular;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #1d1f20;
  /* margin-top: 60px; */
}
body{
  color: #1d1f20;
}

/*.welcome {
  opacity: 0;
  font-size: 22px;
  text-align: center;
  height: 100%;
  width: 100%;
  position: absolute;
  background-color: white;
  color: black;
  z-index: -100;

  -webkit-transition: all 300ms ease-in;
  -moz-transition: all 300ms ease-in;
  -ms-transition: all 300ms ease-in;
  -o-transition: all 300ms ease-in;
  transition: all 300ms ease-in;
}*/

.show {
  opacity: 1;
  z-index: 100
}

@font-face {
  font-family: "ToyotaType-Light";
  src: url(./fonts/ToyotaType-Light.ttf) format("truetype"), url(https://toyota.com/brandguidelines/ToyotaType-Light/ToyotaType-Light.woff) format("woff"), url(https://toyota.com/brandguidelines/ToyotaType-Light/ToyotaType-Light.woff2) format("woff2"), url(https://toyota.com/brandguidelines/ToyotaType-Light/ToyotaType-Light.eot?) format("eot");
  font-style: normal;
  font-weight: 400; }

@font-face {
  font-family: "ToyotaType-Book";
  src: url(./fonts/ToyotaType-Book.ttf) format("truetype"), url(https://toyota.com/brandguidelines/ToyotaType-Book/ToyotaType-Book.woff) format("woff"), url(https://toyota.com/brandguidelines/ToyotaType-Book/ToyotaType-Book.woff2) format("woff2"), url(https://toyota.com/brandguidelines/ToyotaType-Book/ToyotaType-Book.eot?) format("eot");
  font-style: normal;
  font-weight: 400; }

@font-face {
  font-family: "ToyotaType-Regular";
  src: url(./fonts/ToyotaType-Regular.ttf) format("truetype"), url(https://toyota.com/brandguidelines/ToyotaType-Regular/ToyotaType-Regular.woff) format("woff"), url(https://toyota.com/brandguidelines/ToyotaType-Regular/ToyotaType-Regular.woff2) format("woff2"), url(https://toyota.com/brandguidelines/ToyotaType-Regular/ToyotaType-Regular.eot?) format("eot");
  font-style: normal;
  font-weight: 400; }

@font-face {
  font-family: "ToyotaType-Semibold";
  src: url(./fonts/ToyotaType-Semibold.ttf) format("truetype"), url(https://toyota.com/brandguidelines/ToyotaType-Semibold/ToyotaType-Semibold.woff) format("woff"), url(https://toyota.com/brandguidelines/ToyotaType-Semibold/ToyotaType-Semibold.woff2) format("woff2"), url(https://toyota.com/brandguidelines/ToyotaType-Semibold/ToyotaType-Semibold.eot?) format("eot");
  font-style: normal;
  font-weight: 600; }

@font-face {
  font-family: "ToyotaType-Bold";
  src: url(./fonts/ToyotaType-Bold.ttf) format("truetype"), url(https://toyota.com/brandguidelines/ToyotaType-Bold/ToyotaType-Bold.woff) format("woff"), url(https://toyota.com/brandguidelines/ToyotaType-Bold/ToyotaType-Bold.woff2) format("woff2"), url(https://toyota.com/brandguidelines/ToyotaType-Bold/ToyotaType-Bold.eot?) format("eot");
  font-style: normal;
  font-weight: 400; }
</style>
